import moment from 'moment-timezone'
import { LocalizationContextType, DEFAULT_LOCALIZATION_CONTEXT } from '../components/shared/contexts'

type Input = string | number | Date | null | undefined

// Taken from the context default rather than restated, so a caller that passes no localization
// renders what a component reading the context would - and so the two cannot drift apart.
const DEFAULT_DATE_FORMAT = DEFAULT_LOCALIZATION_CONTEXT.date_format
const DEFAULT_TIME_FORMAT = DEFAULT_LOCALIZATION_CONTEXT.time_format ?? 'HH:mm:ss'
const DEFAULT_TIMEZONE = DEFAULT_LOCALIZATION_CONTEXT.timezone ?? 'UTC'

const resolveTimezone = (localization?: LocalizationContextType): string =>
  localization?.timezone || DEFAULT_TIMEZONE

const resolveDateFormat = (localization?: LocalizationContextType): string =>
  localization?.date_format || DEFAULT_DATE_FORMAT

const resolveTimeFormat = (localization?: LocalizationContextType): string =>
  localization?.time_format || DEFAULT_TIME_FORMAT

export const formatTenantDateTime = (
  input: Input,
  localization?: LocalizationContextType
): string => {
  if (input == null || input === '') return ''
  const tz = resolveTimezone(localization)
  const fmt = `${resolveDateFormat(localization)} ${resolveTimeFormat(localization)}`
  return moment.tz(input, tz).format(fmt)
}

export const formatTenantDate = (
  input: Input,
  localization?: LocalizationContextType
): string => {
  if (input == null || input === '') return ''
  return moment.tz(input, resolveTimezone(localization)).format(resolveDateFormat(localization))
}

export const formatTenantTime = (
  input: Input,
  localization?: LocalizationContextType
): string => {
  if (input == null || input === '') return ''
  return moment.tz(input, resolveTimezone(localization)).format(resolveTimeFormat(localization))
}
